import { createFileRoute } from '@tanstack/react-router';
import { EcranAide } from '../aide/EcranAide';

export const Route = createFileRoute('/aide')({
  component: EcranAide,
});
